(function (window) {
  'use strict';

  const secondLevelLinks = document.querySelectorAll('.mobile-navigation__second-level-link')
  const thirdLevelLinks = document.querySelectorAll('.mobile-navigation__third-level-link')
  const backLinks = document.querySelectorAll('.mobile-navigation__back-link')
  const hamburgerIcon = document.querySelector('[aria-controls=\'mobile-navigation\']')
  const headerIconsContainer = document.querySelector('.header__icons')
  const mobileNavigation = document.querySelector('.mobile-navigation')
  const mobileNavigationBaseLevel = document.querySelector('.mobile-navigation__base')

  // If no mobile nav is found, do nothing.
  if (!mobileNavigation) return;

  const body = document.body;
  const html = document.documentElement;
  const nestedMenuTriggers = mobileNavigation.querySelectorAll('a[aria-controls]');

  /**
   * Open the mobile nav
   *
   */
  function openMenu() {
    // make the nav visible
    mobileNavigation.setAttribute('aria-hidden', 'false');

    // add here: call to height adjustment
    adjustMenuHeight(mobileNavigation);

    // add open states to other non-nav elements:
    //  - swap the open/close hamburger icon
    //  - prevent scrolling on body
    headerIconsContainer.classList.add('js-mobile-header-nav-open');
    body.classList.add('js-mobile-header-nav-open');
    html.classList.add('js-mobile-header-nav-open');

    // Trap the keyboard navigation inside the menu while open
    mobileNavigationBaseLevel.querySelector('a').focus();
    mobileNavigationBaseLevel.addEventListener('keydown', keyboardTrapMain);
  }

  /**
   * Close the mobile nav
   *
   */
  function closeMenu() {
    // make the nav invisible
    mobileNavigation.setAttribute('aria-hidden', 'true');

    // remove open states from other page elements
    headerIconsContainer.classList.remove('js-mobile-header-nav-open');
    body.classList.remove('js-mobile-header-nav-open');
    html.classList.remove('js-mobile-header-nav-open');

    // hide and untrap any nested/child menus
    const mobileNavigationNestedMenus = mobileNavigation.querySelectorAll('[aria-hidden]')
    for (let i = 0; i < mobileNavigationNestedMenus.length; i++) {
      mobileNavigationNestedMenus[i].setAttribute('aria-hidden', 'true')
      mobileNavigationNestedMenus[i].removeEventListener('keydown', keyboardTrap)
    }
  }

  /**
   * Nested nav keyboard trap:
   * Trap the user's keyboard within a nested navigation menu when it is open.
   * Close any open nested navs and release trap when the user presses 'ESC'
   */
  function keyboardTrap(e) {
    handleModalKeydown(e, () => {
      // do these things after the user dismisses the menu via ESC

      // get this nested menu's backlink
      const link = e.target;

      let backLink = '';
      // if the target isn't already a backlink, the user has tabbed around in
      // the menu and we need to select the backlink elsewhere
      if (!link.classList.contains('mobile-navigation__back-link')) {
        // get all the nested menus
        const nestedMenus = mobileNavigation.querySelectorAll('.mobile-navigation__second-level, .mobile-navigation__third-level');
        // iterate through the nested menus and find the one with the target
        // inside it — this is the menu we're currently in
        let parentMenu = '';
        nestedMenus.forEach(nestedMenu => {
          if (nestedMenu.contains(link)) {
            parentMenu = nestedMenu;
          }
        });
        // find the backlink in the matched menu
        backLink = parentMenu.querySelector('.mobile-navigation__back-link');

      // otherwise, we're already focused on the backlink
      } else {
        backLink = link;
      }

      // close the nested menu
      closeNestedMenu(e, backLink);

    });
  }

  /**
   * Base level keyboard trap:
   * Trap the user's keyboard within the base level navigation menu when it is open.
   * Close the mobile nav and release trap when the user presses 'ESC'
   */
  function keyboardTrapMain(e) {
    handleModalKeydown(e, () => {
      mobileNavigationBaseLevel.removeEventListener('keydown', keyboardTrapMain)
      closeMenu();
      hamburgerIcon.focus()
    })
  }

  /**
   * Adjust the height of the mobile nav:
   * The mobile nav should be the full height of the screen, minus the other
   * items in the mobile header. This height adjustment prevents any content
   * from being obscured if the nav is set to the full 100vh.
   *
   * @param {object} menu - the nav element to adjust
   *
   */
  function adjustMenuHeight(menu) {
    // get the height of the menu's siblings inside the header. This is
    // typically the header bar (logo, and buttons for cart, search, menu
    // toggle), but may contain other elements in the future.

    // get all the menu's siblings
    const menuSiblings = Array.from(menu.parentNode.children)
      // Keep only the children that are _not_ the mobile nav itself.
      .filter((element) => !element.classList.contains('mobile-navigation'));

    // sum heights of the siblings so we know what to subtract from the menu's
    // height and prevent any content from being hidden at the bottom
    const heightToSubtract = menuSiblings.reduce((height, element) => {
      return height + element.offsetHeight;
    }, 0);

    menu.style.height = `calc(100% - ${heightToSubtract}px)`;

  }

  /**
   * Get the first focusable element within another element
   *
   * @param element - The element we want to search
   *
   * @returns The first element within the searched element that is focusable
   */
  function firstFocusable(element) {
    const focusableElements = [...element.querySelectorAll(
      'a:not([tabindex="-1"]), button:not([tabindex="-1"]), input:not([tabindex="-1"]), textarea:not([tabindex="-1"]), select:not([tabindex="-1"]), details:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
    )]
      .filter(el => !el.hasAttribute('disabled'));

    return focusableElements[0];
  }

  /**
   * Handle clicks on links that open nested menus
   *
   */
  function nestedLinkHandler(e) {
    e.preventDefault();

    // identify the item to toggle and toggle it:
    // each trigger link has an aria-controls attribute that matches the ID of
    // the item to open, so we need that ID as a string to search for its
    // corresponding menu. The click event might have fired on a child element,
    // so we use the event’s currentTarget property to target the element to
    // which this handler is attached.
    const link = e.currentTarget;
    const areaID = link.getAttribute('aria-controls');
    openNestedMenu(areaID, link);
  }

  nestedMenuTriggers.forEach(link => link.addEventListener('click', event => nestedLinkHandler(event)));

  /**
   * Open nested/child menus
   *
   */
  function openNestedMenu(areaID, openerElement) {
    // find the menu we want to open and make it visible
    const areaToOpen = document.querySelector(`#${areaID}`)
    areaToOpen.setAttribute('aria-hidden', 'false');

    // get the first focusable element in the nested menu and focus on it
    const focusElement = firstFocusable(areaToOpen);
    focusElement.focus();

    // init the back link for this area
    const backLink = areaToOpen.querySelector('.mobile-navigation__back-link');
    backLink.openerElement = openerElement;
    backLink.areaToClose = areaToOpen;

    // trap the keyboard contained in this area
    areaToOpen.addEventListener('keydown', keyboardTrap);
  }


  /**
   * Close nested/child menus
   *
   */
  function closeNestedMenu(e, link) {
    e.preventDefault();

    const backLink = link;

    // close the menu
    backLink.areaToClose.setAttribute('aria-hidden', true);

    // put focus back on link that opens this menu
    backLink.openerElement.focus();

    // untrap keyboard
    backLink.areaToClose.removeEventListener('keydown', keyboardTrap);
  }

  backLinks.forEach(link => link.addEventListener('click', event => closeNestedMenu(event, link)))

  /**
   * Toggle the menu via the hamburger icon
   *
   */
  if (hamburgerIcon) {
    hamburgerIcon.addEventListener('click', () => {

      // open the nav if it's hidden, otherwise close it
      if (mobileNavigation.getAttribute('aria-hidden') === 'true') {
        openMenu();
      } else {
        closeMenu();
      }

      // If a flyout is open, close it.
      if (window.componentEvents) {
        componentEvents.emitEvent('close-all-flyouts');
      }
    })
  }

  /**
   * Reset used to repeat all the things in closeMenu(). It's redundant for menu
   * opening/closing now, but called when the user opens a flyout
   *
   */
  function resetMobileMenu() {
    closeMenu();
  }

  /**
   * Tasks to do when the window resizes
   *
   */
  function handleWindowResize() {

    // if the desktop navigation is visible, the user has resized the page to
    // above the mobile breakpoint and we need to close the mobile nav if it's
    // open.

    // Two caveats for future development:

    // 1) This checks for the desktop nav's offsetParent, which won't work if we
    //    ever set the desktop nav to be position:fixed (for example, if we use
    //    that method to make the nav sticky in the future). If so, we'll need
    //    to do this check by iterating through the desktop nav's style
    //    properties for 'display: none' (which is slower than checking for its
    //    offsetParent)

    // 2) This depends on the desktop nav being hidden with display:none, so if
    //    our hiding strategy changes in the future, we'll need to adjust this
    //    check (for example, if we need to use aria-hidden instead)
    if (document.querySelector('.desktop-navigation').offsetParent !== null) {
      closeMenu();
    } else {
      // if we're still within the mobile range, adjust the height of the mobile
      // nav to ensure all of its content is visible within the frozen body
      adjustMenuHeight(mobileNavigation);
    }
  }

  // listen for window resizing
  window.addEventListener('resize', debounce(handleWindowResize, 50));

  // reset the menu if it's closed by another component on the page
  // (for example, if the user opens a flyout)
  if (window.componentEvents) {
    componentEvents.on('close-navigation', resetMobileMenu);
  }

})(this);
